const urlParams = new URLSearchParams(window.location.search);
const voucherParameterKey = "voucherCode";

class VoucherService {
  init = () => {
    if (urlParams.get(voucherParameterKey)) {
      sessionStorage.setItem(
        voucherParameterKey,
        urlParams.get(voucherParameterKey)
      );
    }
  };

  get = () => {
    if (sessionStorage.getItem(voucherParameterKey)) {
      return sessionStorage.getItem(voucherParameterKey);
    }

    return null;
  };
}

export default new VoucherService();
